import script from "./WeModal.vue?vue&type=script&setup=true&lang=js"
export * from "./WeModal.vue?vue&type=script&setup=true&lang=js"

import "./WeModal.vue?vue&type=style&index=0&id=187e9c8c&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-187e9c8c"]])

export default __exports__